import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';

import DateSelector from '../DateSelector';
import SelectorDropDown from '../SelectorDropDown';

import { MAX_NUMBER_OF_NIGHTS, getLabelValueOptionsList } from '../../commons/utils';
import {
  getActualDate,
  addNdays,
  getFirstYearDayDate,
  getDiffNumberFromDates,
  isSameDate,
  removeNdays
} from '../../commons/datesUtils';

class CombinedDatesForm extends React.Component {
  static propTypes = {
    tabIndex: PropTypes.string,
    titleFrom: PropTypes.string,
    titleTo: PropTypes.string,
    titleNights: PropTypes.string,
    defaultLang: PropTypes.string,
    defaultFromDate: PropTypes.string,
    defaultToDate: PropTypes.string,
    minDefaultDate: PropTypes.string,
    maxDefaultDate: PropTypes.string,
    readOnly: PropTypes.bool,
    handleDatesData: PropTypes.func
  }

  static defaultProps = {
    tabIndex: '0',
    titleFrom: '',
    titleTo: '',
    titleNights: '',
    defaultLang: '',
    defaultFromDate: getActualDate(true),
    defaultToDate: addNdays(getActualDate(true), 1, true),
    minDefaultDate: getFirstYearDayDate(true),
    maxDefaultDate: undefined,
    readOnly: false,
    handleDatesData: () => {}
  }

  constructor(props) {
    super(props);
    this.state = {
      betweenNights: getDiffNumberFromDates(this.props.defaultFromDate, this.props.defaultToDate),
      fromDate: this.props.defaultFromDate,
      toDate: this.props.defaultToDate
    };
  }

  componentDidUpdate(prevProps) {
    const { defaultFromDate, defaultToDate } = this.props;
    
    if (!isSameDate(prevProps.defaultFromDate, defaultFromDate)
      || !isSameDate(prevProps.defaultToDate, defaultToDate)) {
      this.setStateOnly(defaultFromDate, defaultToDate);
    } 
  }

  setStateOnly = (newFromDate, newToDate) => {
    this.setState({
      fromDate: newFromDate,
      toDate: newToDate,
      betweenNights: getDiffNumberFromDates(newFromDate, newToDate)
    });
  }

  handleNumberOfNights = (value) => {
    const { fromDate } = this.state;
    const newToDate = addNdays(fromDate, value, true);

    this.setState({
      betweenNights: value,
      toDate: newToDate
    }, () => {
      this.props.handleDatesData(fromDate, newToDate);
    });
  }

  handleFromDate = (value) => {
    const { toDate } = this.state;
    const diffNights = getDiffNumberFromDates(value, toDate);
    const newState = {
      fromDate: value,
      toDate
    };

    if (diffNights > MAX_NUMBER_OF_NIGHTS) {
      newState.toDate = removeNdays(toDate, (diffNights - MAX_NUMBER_OF_NIGHTS), true);
    } else if (diffNights <= 0) {
      newState.toDate = addNdays(value, 1, true);
    }

    newState.betweenNights = getDiffNumberFromDates(value, newState.toDate);

    this.setState(newState, () => {
      this.props.handleDatesData(value, newState.toDate);
    })
  }

  handleToDate = (value) => {
    const { fromDate } = this.state;
    const diffNights = getDiffNumberFromDates(fromDate, value);
    
    this.setState({
      toDate: value,
      betweenNights: diffNights
    }, () => {
      this.props.handleDatesData(fromDate, value);
    });
  }

  render() {
    const {
      tabIndex,
      titleFrom,
      titleTo,
      titleNights,
      defaultLang,
      minDefaultDate,
      maxDefaultDate,
      readOnly
    } = this.props;

    const { fromDate, toDate, betweenNights } = this.state;

    const maxToDate = addNdays(fromDate, MAX_NUMBER_OF_NIGHTS, true);

    return (
      <Row className="auto-margin">
        <Col sm="5" className="no-padding-left">
          <DateSelector
            tabIndex={tabIndex}
            title={titleFrom}
            dataTestLabel="fecha-entrada"
            defaultDate={fromDate}
            minDate={minDefaultDate}
            maxDate={maxDefaultDate}
            defaultLang={defaultLang}
            checkPrevProps
            readOnly={readOnly}
            handleDateSelected={this.handleFromDate}
          />
        </Col>
        <Col sm="5" className="no-padding-left">
          <DateSelector
            tabIndex={tabIndex}
            title={titleTo}
            dataTestLabel="fecha-salida"
            defaultDate={toDate}
            minDate={addNdays(fromDate, 1, true)}
            maxDate={maxToDate}
            defaultLang={defaultLang}
            checkPrevProps
            readOnly={readOnly}
            handleDateSelected={this.handleToDate}
          />
        </Col>
        <Col sm="2" className="no-padding">
          <SelectorDropDown
            tabIndex={tabIndex}
            title={titleNights}
            dataTestLabel="numero-noches"
            options={getLabelValueOptionsList(MAX_NUMBER_OF_NIGHTS, false)}
            defaultValue={betweenNights}
            checkPrevProps
            readOnly={readOnly}
            isSearchable={false}
            handleSelectOption={this.handleNumberOfNights}
          />
        </Col>
      </Row>
    );
  }
}

export default CombinedDatesForm;
